import { useCallback, useEffect, useState } from 'react';

/**
 * A seconds countdown. `remaining` is 0 when idle; `start(n)` restarts it at `n`.
 *
 * One interval per running countdown, cleared when it reaches zero or the component unmounts.
 */
export const useCooldown = (initialSeconds = 0) => {
  const [remaining, setRemaining] = useState(initialSeconds);
  const running = remaining > 0;

  useEffect(() => {
    if (!running) return;

    const id = window.setInterval(() => {
      setRemaining((current) => Math.max(0, current - 1));
    }, 1000);

    return () => window.clearInterval(id);
  }, [running]);

  const start = useCallback((seconds: number) => {
    setRemaining(Math.max(0, Math.floor(seconds)));
  }, []);

  return { remaining, start };
};
